<template>
    <div>
        <br/>
        <b-overlay :show="loading" rounded="sm">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            {{ $t('order.form.title.client')}}
                        </div>
                        <div class="card-body">
                            <br/>
<!--------------- Первая строка первого блока ---------------------->
                            <div class="row">
                                <div class="col-sm-1">
                                    {{$t('order.form.data.phone')}}: *
                                </div>
                                <div class="col-sm-3">
                                    <phoneForm
                                        id="phone"
                                        ref="phone"
                                        :tabindex="1"
                                        :bus="localbus_p"
                                        @result="setPhoneObj"
                                        @setPhone="setPhone"
                                    >
                                    </phoneForm>
                                </div>
                                <div class="col-sm-1">
                                    {{$t('order.form.data.name')}}: *
                                </div>
                                <div class="col-sm-3">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="order.firstName" id="firstName" ref="firstName" autocomplete="off" required tabindex="2" @change="resetError($event)">
                                        <div class="invalid-feedback">
                                            {{$t('order.form.data.you_missed_this_field')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-1">
                                    {{$t('order.form.data.surname')}}:
                                </div>
                                <div class="col-sm-3">
                                    <input type="text" class="form-control" v-model="order.lastName" autocomplete="off" tabindex="3">
                                </div>
                            </div>
<!--------------- Вторая строка первого блока ---------------------->
                            <br/>
                            <div class="row">
                                <div class="col-sm-1">
                                    {{$t('order.form.data.additional_phone')}}:
                                </div>
                                <div class="col-sm-3">
                                    <input type="text" class="form-control" v-model="order.additionalPhone" id="additionalPhone" ref="additionalPhone" autocomplete="off" tabindex="4">
                                </div>
                                <div class="col-sm-1">
                                    {{$t('order.form.data.client_gender')}}: *
                                </div>
                                <div class="col-sm-3">
                                    <div class="input-group">
                                        <select class="form-control" v-model="order.sex" id="sex" ref="sex" @change="resetError($event)" tabindex="5">
                                            <option value="male">{{$t('order.form.data.male')}}</option>
                                            <option value="female">{{$t('order.form.data.female')}}</option>
                                        </select>
                                        <div class="invalid-feedback">
                                            {{$t('order.form.data.you_missed_this_field')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-1">
                                    {{$t('order.form.data.date_of_birth')}}:
                                </div>
                                <div class="col-sm-3">
                                    <div class="input-group">
                                        <input type="date" class="form-control" v-model="order.birthdate" id="birthdate" ref="birthdate" autocomplete="off" tabindex="6">
                                        <div class="invalid-feedback">
                                            {{$t('main.invalid_date_of_birth_format')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
<!--------------- Третья строка первого блока ---------------------->
                            <br/>

                            <div class="row" >
                                <template v-if="rule_order_source">
                                    <div class="col-sm-1">
                                        {{$t('order.form.data.digital_source')}}:
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="input-group">
                                            <select class="form-control" v-model="order.source" id="source" ref="source" tabindex="7">
                                                <option v-for="(item, index) in reference.digital_source.ether" :key="item.value" :value="item.value">
                                                    {{item.text}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col-sm-1"></div>
                                    <div class="col-sm-3"></div>
                                </template>
                                <template v-if="typeof order.customer.customer_id !== 'undefined'">
                                    <div class="col-sm-1">{{$t('main.customer')}}: </div>
                                    <div class="col-sm-3">
                                        <button class="btn" @click="showCustomer(order.customer.customer_id)">
                                            {{order.customer.name}}
                                            <template v-if="typeof order.customer.club_card !== 'undefined' && order.customer.club_card!=''">
                                                (Card valid until {{ order.customer.club_card }})
                                            </template>
                                        </button>
                                        <div class="btn-square btn-square_cancel" role="button" @click="resetCustomer"> </div>
                                    </div>
                                    <div class="col-sm-4"></div>
                                </template>
                                <template v-else>
                                    <div class="col-sm-8"></div>
                                </template>
                            </div>
                            <br/>
                        </div>
                    </div>
                </div>
            </div>

            <br/>
            <div class="row">
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-header">
                            Адрес
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-3">
                                    {{$t('order.form.data.region')}}: *
                                </div>
                                <div class="col-sm-9">
                                    <div class="input-group">
                                        <select class="form-control" v-model="order.region" id="region" ref="region" tabindex="12" @change="resetError($event)">
                                            <option v-for="(item, index) in regions" :key="item.value">
                                                {{item.text}}
                                            </option>
                                        </select>
                                        <div class="invalid-feedback">
                                            {{$t('order.form.data.you_missed_this_field')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <div class="row">
                                <div class="col-sm-3">
                                    {{$t('order.form.data.city')}}: *
                                </div>
                                <div class="col-sm-9">
                                    <div class="input-group">
                                        <cityForm
                                            id="city"
                                            ref="city"
                                            :isError="city_error"
                                            :region="order.region"
                                            :city="order.city"
                                            :tabindex="13"
                                            @result="setCity"
                                            @setValue="setValue"
                                        >
                                        </cityForm>
                                        <div class="invalid-feedback">
                                            {{$t('order.form.data.you_missed_this_field')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="order.city_obj?.is_mountainous_region" class="row mt-1">
                                <div class="col-sm-4">
                                    <b-badge show pill class=""variant="danger" >
                                        Горная местность
                                    </b-badge>
                                </div>
                                <div class="col-sm-8">
                                    <div class="">
                                        <p style="font-size: small; position: absolute; top: 10%" class="mb-0">Доставка может задержаться</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="order.city_obj?.not_deliver" class="row mt-1">
                                <div class="col-sm-4">
                                    <b-badge show pill class=""variant="danger" >
                                        Нет доставки
                                    </b-badge>
                                </div>
                                <div class="col-sm-8">
                                    <div class="">
                                        <p style="font-size: small; position: absolute; top: 10%" class="mb-0">Добавьте новый город</p>
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <template v-if="order.city_obj!==null && typeof order.city_obj.not_deliver !== 'undefined' && order.city_obj.not_deliver">
                                <div class="row">
                                    <div class="col-sm-3">
                                        Город доставки: *
                                    </div>
                                    <div class="col-sm-9">
                                        <div class="input-group">
                                            <cityForm
                                                id="city_delivery"
                                                ref="city_delivery"
                                                :isError="city_error"
                                                region=""
                                                :city="order.city_delivery"
                                                :tabindex="12"
                                                @result="setCityDelivery"
                                                @setValue="setValueDelivery"
                                            >
                                            </cityForm>
                                            <div class="invalid-feedback">
                                                {{$t('order.form.data.you_missed_this_field')}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br/>
                            </template>
                            <br/>
                            <div class="row">
                                <div class="col-sm-3">
                                    {{$t('order.form.data.address')}}: *
                                </div>
                                <div class="col-sm-9">
                                    <div class="input-group">
                                        <textarea class="form-control" rows="4" v-model="order.address" id="address" ref="address" autocomplete="off" required tabindex="14" @change="resetError($event)"></textarea>
                                        <div class="invalid-feedback">
                                            {{$t('order.form.data.you_missed_this_field')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/><br/>
                </div>
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-header">
                            Данные заявки
                        </div>
                        <div class="card-body">
                            <div class="row" v-if="show_delivery_date">
                                <div class="col-sm-3">
                                    {{$t('order.form.data.delivery_date')}}: *
                                </div>
                                <div class="col-sm-9">
                                    <b-datepicker v-model="order.delivery_date" :min="min_date_delivery" id="deliverydate" ref="deliverydate" @change="resetError($event)" class="form-control"></b-datepicker>
                                </div>
                            </div>
                            <br/>
                            <div class="row" v-if="show_delivery_date">
                                <div class="col-sm-3">
                                    {{$t('main.time_period')}}: *
                                </div>
                                <div class="col-sm-9">
                                    <select class="form-control" v-model="order.delivery_time" id="deliverytime" ref="deliverytime" @change="resetError($event)">
                                        <option value="10-14">10:00 – 14:00</option>
                                        <option value="14-18">14:00 – 18:00</option>
                                        <option value="18-22">18:00 – 22:00</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        {{$t('order.form.data.you_missed_this_field')}}
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <div class="row" v-if="show_delivery_date">
                                <div class="col-sm-3">
                                    {{$t('main.number_patients')}}: *
                                </div>
                                <div class="col-sm-9">
                                    <select class="form-control" v-model="order.countmen" id="countmen" ref="countmen" @change="resetError($event)">
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4+</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        {{$t('order.form.data.you_missed_this_field')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/><br/>
                </div>
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-header">
                            {{$t('order.form.title.operator_comments')}}
                        </div>
                        <div class="card-body">
                            <textarea class="form-control" rows="3" v-model="order.commentOperator" tabindex="17"></textarea>
                        </div>
                    </div>
                    <br/><br/><br/>
                </div>
            </div>

            <b-navbar type="light" variant="light" style="border-top: 1px solid rgba(0, 0, 0, 0.1);">
                <b-button variant="danger" @click="cancelForm">
                    {{$t('main.cancel')}}
                </b-button>&nbsp;
                <b-button variant="success" @click="submitForm(false, false)" :disabled="disabled_send_form">
                    <b-icon-calendar-check></b-icon-calendar-check>
                        {{$t('main.save')}}
                </b-button>&nbsp;
                <b-button variant="info" @click="submitForm(false, true)" v-if="order.city_obj !== null && order.city_obj.not_deliver && (order.city_obj_delivery == null || typeof order.city_obj_delivery.city_id == 'undefined')">
                    <b-icon-calendar-check></b-icon-calendar-check>
                    Отправить в Отказ до отгрузки
                </b-button>&nbsp;&nbsp;
                <p v-show="alerts.length > 0" style="padding-left: 20px;padding-top: 15px;" class="text-danger">
                    {{ alerts[0] }}
                </p>
            </b-navbar>
        </b-overlay>
        <br/><br/>
    </div>
</template>

<style>
    table#cart th {
        text-align: center;
    }

    .btn-square {
        background-position: 50%;
        background-repeat: no-repeat;
        border: 1px solid #d8d8d8;
        border-radius: 4px;
        cursor: pointer;
        display: inline-block;
        height: 30px;
        vertical-align: middle;
        width: 30px;
    }

    .btn-square_cancel {
        background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20fill='none'%20viewBox='0%200%2024%2024'%3E%3Cpath%20fill='%23AFB9C3'%20d='M7.113%206.176a.6.6%200%200%201%20.848%200L12%2010.214l4.038-4.038a.6.6%200%200%201%20.849%200l.937.937a.6.6%200%200%201%200%20.848L13.785%2012l4.04%204.04a.6.6%200%200%201%200%20.848l-.937.937a.6.6%200%200%201-.849%200L12%2013.784l-4.038%204.04a.6.6%200%200%201-.849%200l-.937-.937a.6.6%200%200%201%200-.848l4.04-4.04-4.039-4.038a.6.6%200%200%201%200-.849l.937-.936Z'/%3E%3C/svg%3E);
        background-size: 16px;
    }
</style>

    <script>
import Vue from 'vue';
import Axios from 'axios';
import cityForm from "@/components/cityForm.vue";
import phoneForm from "@/components/PhoneForm.vue";
import bus from "@/bus";

    Vue.filter("formatNumber", function (value) {
        return new Intl.NumberFormat().format(value);
    });

export default {
    name: 'OrderOptic',

        components: {
            cityForm,
            phoneForm
    },
    props: [ 'call_id' ],
        data: function () {
        return {
            alerts:             [],                 // Массив сообщений
            loading:            false,
            rules: {
                discount:         false               // права на скидки
            },
            products:           [],                 // массив товаров
            order: {
                method: 	      'save',
                ether_id:         0,
                order_id:         0,
                manager:          '',                 // Имя менеджера
                typeOrder:        'optic',         // тип заказа
                site:             'optic',              // название магазина
                customer:         {
                    customer_id:    undefined,
                    name:           '',
                    club_card:      '',
                    start_club:     '',
                    vip:            false,
                    coupons:        []
                },
                lastName:         '',                 // фамилия клиента
                firstName:        '',                 // имя клиента
                sex:              '',                 // Пол клиента
                birthdate:        '',                 // Дата рождения
                phone:            '',                 // телефон клиента
                additionalPhone:  '',                 // дополнительный телефон клиента
                source:           '',
                warehouse:        'sklad-iuvelirka',    // склад отгрузки
                postcode:         '',                   // индекс
                region:           '',                 // регион доставки
                city:             '',                 // город доставки
                city_delivery:    '',
                city_obj:         null,               // объект города city_id, city_name, area_name, region_name
                city_obj_delivery:null,
                address:          '',                 // адрес доставки

                commentOperator:  '',                 // комментарий оператора
                delivery_date:    '',
                delivery_time:    '',
                countmen:         0,
                status:           '',
                revision:         false,
                express_delivery: false,              // Экспресс доставка
                call_id:          0
            },
            city_error: false,                       // флаг ошибки в городе, прокидывается в компонент
            disabled_send_form: false,
            disabled_reserve_form: true,             // показать кнопку резерва
            disabled_discount:      false,
            details: true,
            skip_search: true,
            local_ethers: [],
            ethers: [
                { value: 0, text: this.$t('order_lots.form.data.please_make_a_choice') },
                { value: -1, text: this.$t('order_lots.form.data.selling_from_a_catalog') }
            ],
            options_delivery_date: [],
            delivery_cost: 0,
            so: {
                options_status: []
            },
            localbus_p: new Vue(),
            min_date_delivery: '',
            max_date_delivery: ''
        }
    },

    metaInfo() {
        return {
            title: this.$t('order_lots.title')
        }
    },

    mounted() {
        this.ether_id = 0;

        this.delivery_cost =     this.getDeliveryCost(this.order.city_obj);
        this.order.delivery_cost = this.delivery_cost;
        this.min_date_delivery = this.getDateTomorrow();
        if (typeof this.$route.params.id === 'undefined') {
            bus.$emit('set-header', 'Панель оператора :: Заявка на вызов врача');
        }else{
            bus.$emit('set-header', 'Панель оператора :: Заявка на вызов врача');
            this.order.order_id = this.$route.params.id;
            this.loadOrder(this.order.order_id);
        }

        if (typeof this.call_id !== 'undefined') {
            this.order.call_id = this.call_id;
        }
    },

    methods: {
        setPhoneObj(result){
            this.order.customer   = result;
            this.order.firstName  = result.firstName;
            this.order.lastName   = result.lastName;
            this.order.phone      = result.phone;
            this.order.sex        = result.sex;
            this.order.birthdate  = result.birthdate;
            this.order.postcode   = result.postcode;
            this.order.address    = result.address;
            if (this.order.prepayment_phone == '') this.order.prepayment_phone = result.phone;
            this.setCity({ city_id: result.city_id, city_name: result.city_name, area_name: result.area_name, region_name: result.region_name, lang: 'russian' });
        },

        setPhone(val){
            this.order.phone = val;
            this.order.prepayment_phone = val;
        },

        resetCustomer(){
            this.order.customer     = {
                customer_id: undefined,
                name: '',
                club_card: '',
                start_club: '',
                vip: false,
                coupons: []
            };
            this.order.firstName    = '';
            this.order.lastName     = '';
            this.order.sex          = '';
            this.order.birthdate    = '';
            this.order.postcode     = '';
            this.order.city         = '';
            this.order.region       = '';
            this.order.city_obj     = {};
            this.order.address      = '';
        },

        showCustomer(customer_id){
            bus.$emit('portal:customer:open', customer_id);
        },

        loadOrder(order_id) {
            this.loading = true;
            Axios
                .post(this.prefix_url + '/api/optic?ts=' + Date.now(), {
                    method: 'load',
                    order_id: order_id
                }).then(response => {
                console.log(response);
            this.order = response.data.order;
            this.so.options_status = response.data.statuses;
            this.loadEthers(this.order.ether_id);

            this.loading = false;
        });
    },

    submitForm(flag_reserve, se) {
        let el = '';
        let _this = this;
        let flag_only_vip = false;


        if (this.order.firstName === '') {
            if (el === '') el = 'firstName';
            this.$refs.firstName.classList.value = this.$refs.firstName.classList.value + " is-invalid";
        }
        if (this.order.sex === '') {
            if (el === '') el = 'sex';
            this.$refs.sex.classList.value = this.$refs.sex.classList.value + " is-invalid";
        }
        if (this.order.region === '') {
            if (el === '') el = 'region';
            this.$refs.region.classList.value = this.$refs.region.classList.value + " is-invalid";
        }
        if (this.order.city === '') {
            if (el === '') el = 'city';
            this.city_error = true;
        }
        if (this.order.address === '') {
            if (el === '') el = 'address';
            this.$refs.address.classList.value = this.$refs.address.classList.value + " is-invalid";
        }

        if (el != '') {
            console.log(el);
            this.alerts.push(this.$t('order.form.data.errors_were_found_correct_them_and_save_the_order_again'));
            bus.$emit('view-message', { message: this.$t('order.form.data.errors_were_found_correct_them_and_save_the_order_again'), variant: 'danger' });
            this.focusRef(this.$refs[el]);
            return;
        } else {
            if (this.order.phone === '') {
                this.alerts.push(this.$t('order.form.data.errors_were_found_correct_them_and_save_the_order_again_empty_phone'));
                bus.$emit('view-message', { message: this.$t('order.form.data.errors_were_found_correct_them_and_save_the_order_again'), variant: 'danger' });
                return;
            }
            if (this.order.delivery_date === '') {
                this.alerts.push(this.$t('Укажите дату доставки'));
                bus.$emit('view-message', { message: this.$t('Укажите дату доставки'), variant: 'danger' });
                return;
            }
            if (this.order.delivery_time === '') {
                this.alerts.push(this.$t('Укажите время доставки'));
                bus.$emit('view-message', { message: this.$t('Укажите время доставки'), variant: 'danger' });
                return;
            }
            if (this.order.countmen === '' || this.order.countmen == '0') {
                this.alerts.push(this.$t('Укажите количество пациентов'));
                bus.$emit('view-message', { message: this.$t('Укажите количество пациентов'), variant: 'danger' });
                return;
            }
            if (this.order.city_obj !== null && this.order.delivery_date === '' && this.show_delivery_date) {
                if (el === '') el = 'deliverydate';
                this.alerts.push(this.$t('order.form.data.select_delivery_date_option'));
                bus.$emit('view-message', { message: this.$t('order.form.data.select_delivery_date_option'), variant: 'danger' });
                this.focusRef(this.$refs[el]);
                return;
            }

            if (!se && this.order.city_obj !== null && typeof this.order.city_obj.not_deliver !== 'undefined' && this.order.city_obj.not_deliver && this.order.city_obj_delivery === null) {
                if (el === '') el = 'city_delivery';
                bus.$emit('view-message', { message: 'В этот пункт не доставляем, выберите другой или отправьте в отказ до отгрузки', variant: 'danger' });
                this.focusRef(this.$refs[el]);
                return;
            }


            if (!this.ValidPhone(this.order.phone)) {
                if (el === '') el = 'phone';
                this.$refs.phone.classList.value = this.$refs.phone.classList.value + " is-invalid";
                this.alerts.push(this.$t('order.form.data.invalid_phone_number_format'));
                bus.$emit('view-message', { message: this.$t('order.form.data.invalid_phone_number_format'), variant: 'danger' });
                this.focusRef(this.$refs[el]);
                return;
            }

            if (this.order.birthdate!='' && !this.ValidDate(this.order.birthdate)) {
                if (el === '') el = 'birthdate';
                this.$refs.birthdate.classList.value = this.$refs.birthdate.classList.value + " is-invalid";
                this.alerts.push(this.$t('order.form.data.invalid_date_of_birth_format'));
                bus.$emit('view-message', { message: this.$t('order.form.data.invalid_date_of_birth_format'), variant: 'danger' });
                this.focusRef(this.$refs[el]);
                return;
            }

            if (this.order.additionalPhone != '' && !this.ValidPhone(this.order.additionalPhone)) {
                if (el === '') el = 'additionalPhone';
                this.$refs.additionalPhone.classList.value = this.$refs.additionalPhone.classList.value + " is-invalid";
                this.alerts.push(this.$t('order.form.data.invalid_phone_extension_format'));
                bus.$emit('view-message', { message: this.$t('order.form.data.invalid_phone_extension_format'), variant: 'danger' });
                this.focusRef(this.$refs[el]);
                return;
            }

            if (this.order.additionalPhone != '' && this.order.additionalPhone == this.order.phone) {
                if (el === '') el = 'additionalPhone';
                this.$refs.additionalPhone.classList.value = this.$refs.additionalPhone.classList.value + " is-invalid";
                this.alerts.push(this.$t('order.form.data.the_extension_number_must_not_be_equal_to_the_main_phone_number'));
                bus.$emit('view-message', { message: this.$t('order.form.data.the_extension_number_must_not_be_equal_to_the_main_phone_number'), variant: 'danger' });
                this.focusRef(this.$refs[el]);
                return;
            }
        }
        this.order.manager = this.userName;

        let data = JSON.stringify(this.order);

        this.disabled_send_form = true;

        Axios
            .post(this.prefix_url + '/api/optic/?ts=' + Date.now(), this.order)
            .then(res => {
                this.disabled_send_form = false;

                if (res.data.success) {
                    bus.$emit('view-message', { message: this.$t('order.form.data.order_created_successfully'), variant: 'success' });
                    this.disabled_reserve_form = true;

                    bus.$emit('end-call', parseInt(this.order.call_id));
                    this.order.call_id = 0;

                    this.close(false);
                    this.$router.push('/orders');
                } else {
                    this.alerts.push(res.data.message);
                    bus.$emit('view-message', { message: res.data.message, variant: 'danger' });
                }
            }).catch(error => console.log(error));
        },

        cancelForm() {
            this.close(true);
            this.$router.back();
        },


        ValidPhone(phone) {
            let str = phone.replace(/\D/g, '');
            var re = /^\d{9}$/;
            if (typeof process.env.VUE_APP_COUNTRY === 'undefined' || process.env.VUE_APP_COUNTRY == 'uz' || process.env.VUE_APP_COUNTRY == 'pl') re = /^\d{9}$/;
            else if (process.env.VUE_APP_COUNTRY == 'kz') re = /^\+?7?\d{10}$/;
            else re = /^\+?7?\d{10}$/;

            return re.test(phone);
        },

        ValidDate(date){
            var re = /^\d{4}-\d{2}-\d{2}$/;
            return re.test(date);
        },

        focusRef(ref) {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    ;(ref.$el || ref).focus()
                })
            })
        },

        resetError(e) {
            let el = e.target.id;
            this.$refs[el].classList.value = "form-control";
            if (this.alerts.length > 0) this.alerts = [];

            this.min_date_delivery = this.getDateTomorrow();
            if (el == 'region') {
                this.order.city     = '';
                this.order.city_obj = null;
                this.order.delivery_date = '';

//                this.calc_delivery_period(this.order.region, this.order.city_obj);
            }
        },

        calc_delivery_period(ragion, city_obj){
            let period = (this.getDeliveryPeriod(region));
            let date = new Date();
            let expr = date.setDate(date.getDate() + period );
            console.log('min', new Date(expr), period);
            this.min_date_delivery =  new Date(expr);

            let date2 = new Date();
            expr = date2.setDate(date2.getDate() + period + 2);
            console.log('max', new Date(expr));
            this.max_date_delivery = new Date(expr);

            if ((city_obj !== null && typeof city_obj.city_id !== 'undefined' && city_obj.city_id != 507730 && this.order.express_delivery) || (city_obj == null || typeof city_obj.city_id == 'undefined') ) this.order.express_delivery = false;
            this.delivery_cost =   this.getDeliveryCost(city_obj);
            this.order.delivery_cost = this.delivery_cost;
        },

        setValue(value){
            this.order.city     = value;
            this.order.city_obj = null;
        },

        setCity(city) {
            this.order.city_obj   = city;

            if (city.lang=='russian') this.order.city       = city.city_name;else this.order.city       = city.city_name_uz;
            if (city.not_deliver){
                bus.$emit('view-message', { message: 'Добавьте новый город доставки', variant: 'info' });
            }
            this.order.region     = city.region_name;
            this.city_error       = false;
//            this.calc_delivery_period(city.region, city);

            this.delivery_cost        = this.getDeliveryCost(city);
            this.order.delivery_cost  = this.delivery_cost;
        },


        setValueDelivery(value){
            this.order.city_delivery     = value;
            this.order.city_obj_delivery = null;
        },

        setCityDelivery(city) {
            if (city.not_deliver) {
                this.order.city_delivery     = '';
                bus.$emit('view-message', { message: 'В этот пункт не доставляем, выберите другой', variant: 'danger' });
                return;
            }
            this.order.city_obj_delivery   = city;
            if (city.lang == 'russian') this.order.city_delivery       = city.city_name;else this.order.city_delivery       = city.city_name_uz;
            this.city_error       = false;
//            this.calc_delivery_period(city.region_name, this.order.city_obj_delivery);
            this.delivery_cost =   this.getDeliveryCost(this.order.city_obj_delivery);
        },

        getDateToday(){
            return this.getDatePeriod(0);
        },

        getDateTomorrow(){
            return this.getDatePeriod(1);
        },

        getDatePeriod(day){
            let today = new Date(Date.now() + 86400000 * day);
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = today.getFullYear();
            return yyyy + '-' + mm + '-' + dd;
        },

        getSecondsToday() {
            let now = new Date();

            let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

            let diff = now - today; // разница в миллисекундах
            return Math.round(diff / 1000); // получаем секунды
        },

        getDeliveryPeriod(region) {
            let loc = this.$store.getters.getLocal;
            let regions = loc.regions;
            let obj = regions.find(o => o.text === region);
            if (typeof obj !== 'undefined') return obj.delivery_period;

            return 1;
        },

        getDeliveryCost(city_obj) {
            let loc = this.$store.getters.getLocal;
            let dc  = loc.cost_by_city;

            if (this.order.express_delivery) return 49000;

            if (city_obj !== null && typeof city_obj.city_id !== 'undefined') {
                let obj = dc.find(o => o.city_id == city_obj.city_id);
                if (typeof obj !== 'undefined') return obj.cost;
            }
            return loc.delivery_cost;
        },


        close(removeReserve = false){
            let _this = this;
            this.order.manager          = '';
            this.order.typeOrder        = 'optic';
            this.order.site             = 'optic';
            this.order.lastName         = '';
            this.order.firstName        = '';
            this.order.sex              = '';
            this.order.birthdate        = '';
            this.order.phone            = '';
            this.order.additionalPhone  = '';
            this.order.source           = '';
            this.order.warehouse        = 'sklad-iuvelirka';
            this.order.region           = '';
            this.order.city             = '';
            this.order.city_obj         = null;
            this.order.address          = '';
            this.order.commentOperator  = '';
            this.order.delivery_cost    = this.delivery_cost;
            this.order.status           = '';
            this.order.customer         = {
                customer_id: undefined,
                name: '',
                club_card: '',
                start_club: '',
                vip: false,
                coupons: []
            };
        },
    },

    computed: {
        userName: function () {
            return this.$store.getters.getUserName
        },

        regions: function () {
            let loc = this.$store.getters.getLocal;
            return loc.regions;
        },

        reference: function () {
            let loc = this.$store.getters.getLocal;
            return loc.reference;
        },

        currency: function () {
            let loc = this.$store.getters.getLocal;
            return loc.currency;
        },

        show_delivery_date: function () {
            let loc = this.$store.getters.getLocal;
            if (typeof loc.show_delivery_date === 'undefined') return false;
            return loc.show_delivery_date;
        },

        country: function () {
            if (typeof process.env.VUE_APP_COUNTRY === 'undefined') return '';
            return process.env.VUE_APP_COUNTRY;
        },
        rule_order_source: function (){return this.$store.getters.getRule('order_source') },
        rule_tv_admin: function (){return this.$store.getters.getRule('tv_admin') },
        prefix_url:function () { return process.env.VUE_APP_PREFIX_URL }
    },

    watch: {
        order: {
            handler(val) {
                this.delivery_cost = this.getDeliveryCost(this.order.city_obj);
            }
        }
    }
}
</script>